import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Paper,
  CircularProgress,
  Alert,
} from '@mui/material';
import { Payment as PaymentIcon } from '@mui/icons-material';
import { useAuthContext } from '../../../context/AuthContext';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const ShowTimePayment = () => {
  const { showTimeId } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuthContext();

  React.useEffect(() => {
    if (!isAuthenticated || !user) {
      navigate('/login', { state: { from: `/showtime/payment/${showTimeId}` } });
    }
  }, [isAuthenticated, user, navigate, showTimeId]);

  const handlePaidClick = async () => {
    setError('');
    setLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const res = await fetch(`${API_BASE}/api/show-times/complete-payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ showTimeId: parseInt(showTimeId, 10) }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Failed');
        return;
      }
      navigate(data.redirectTo || '/mindyourmusic');
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthenticated || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress sx={{ color: '#FF6B9D' }} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(180deg, #0a0015 0%, #1a0033 50%, #0a0015 100%)',
        p: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 440,
          width: '100%',
          p: 4,
          backgroundColor: 'rgba(30,30,50,0.95)',
          border: '2px solid rgba(255,107,157,0.4)',
          borderRadius: 3,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <PaymentIcon sx={{ fontSize: 48, color: '#FF6B9D', mr: 2 }} />
          <Typography variant="h5" sx={{ color: '#fff', fontWeight: 700 }}>
            Payment
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ color: '#B0B0B0', mb: 3 }}>
          Payment gateway coming soon. Click below to simulate payment and proceed.
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Button
          fullWidth
          variant="contained"
          disabled={loading}
          onClick={handlePaidClick}
          sx={{
            background: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)',
            color: '#fff',
            py: 1.5,
            fontWeight: 700,
            '&:hover': { background: 'linear-gradient(135deg, #388E3C 0%, #1B5E20 100%)' },
          }}
        >
          {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Paid — Enter'}
        </Button>
      </Paper>
    </Box>
  );
};

export default ShowTimePayment;
